import { useRuntimeConfig } from "@finbackoffice/site-core";
import { ISmarticoProps, SmarticoScript } from "components/base/external-scripts/SmarticoScript";
import {
    createContext,
    FC,
    PropsWithChildren,
    useCallback,
    useContext,
    useMemo,
    useState,
} from "react";
import { UserAccountContextV2 } from "./user-account-v2.provider";

type ICrmContext = {
    unreadMessagesCount: number;
    openInbox: () => void;
    openGamificationUi: () => void;
};

export const CrmContext = createContext<ICrmContext>(null as any);

export const CrmProvider: FC<{ locale: string } & PropsWithChildren> = ({ children, locale }) => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { userId } = useContext(UserAccountContextV2);
    const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

    const onLoadHandler = useCallback(() => {
        window._smartico.on("props_change", function (props: ISmarticoProps) {
            if (props.core_inbox_unread_count) {
                setUnreadMessagesCount(props.core_inbox_unread_count);
            }
        });
    }, []);

    const openGamificationUi = useCallback(() => {
        window._smartico.dp("dp:gf");
    }, []);

    const openInbox = useCallback(() => {
        window._smartico.dp("dp:inbox");
    }, []);

    const value = useMemo(
        () => ({
            unreadMessagesCount,
            openGamificationUi,
            openInbox,
        }),
        [unreadMessagesCount, openGamificationUi, openInbox],
    );

    return (
        <CrmContext.Provider value={value}>
            {COMMON_SITE_CONFIGS.crm.enable && (
                <SmarticoScript onLoad={onLoadHandler} locale={locale} userId={userId} />
            )}
            {children}
        </CrmContext.Provider>
    );
};
